export default __webpack_public_path__ + "static/mar-email-behavior-dcbf00593fdfbf96d64cfc544babdeaa.png";